<template>
  <La1 id="ingredient" :ratio="'repeat(2, 1fr)'">
    <template slot="left">
      <div class="cubes" :style="{borderColor: 'var(--color-checked)'}">
      <div :style="{backgroundColor: 'var(--color-checked)'}">
          <div>使用原料</div>
          <button class="save" @click="save">儲存</button>
        </div>
        <div class="items compose">
        <div v-for="(ingred, i) in compose" :key="`ingreds-${i}`">
          <NumInput :defaultValue="ingred.count" @input="ingred.count=$event" :width="'80px'"/>
          <div>{{ingred.ingredient.name}}({{ingred.ingredient.unit}})</div>
          <button class="del" @click="compose.splice(i, 1)"></button>
        </div>
        </div>
      </div>
    </template>
    <div class="cubes" :style="{borderColor:'var(--color-pri)'}">
      <div :style="{backgroundColor: 'var(--color-pri)'}">
        <div>原料列表</div>
        <input type="text" :placeholder="'搜尋'" class="search" :value="searchText" @change="searchText=$event.target.value">
      </div>
      <div class="items ingred">
        <div v-for="(inge, i) in ingreds" :key="`ingreds-${i}`">
          <button class="add" @click="compose.push({ count: 1, ingredient: inge })"></button>
          <div>{{inge.name}}({{inge.unit}})</div>
        </div>
      </div>
    </div>
  </La1>
</template>

<script>
import NumInput from '../../../../components/input/countEditable.vue'
import La1 from '../../../../components/layout/La1.vue'
import { getapi, postapi } from '../../../../store/fetch'
export default {
  components: {
    La1,
    NumInput
  },
  data () {
    return {
      ingreds: ['牛奶', '雞蛋'],
      compose: [],
      searchText: null
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  async mounted () {
    await this.getingreds()
  },
  watch: {
    id: {
      async handler () {
        if (this.id) {
          const compose = await getapi(`rest_product/single/ingredients/${this.id}`)
          this.compose = (compose && compose.ingredients) || []
        } else {
          this.compose = []
        }
      },
      immediate: true
    },
    async searchText () {
      await this.getingreds()
    }
  },
  methods: {
    async save () {
      const r = await postapi(`rest_product/single/${this.id}`, { ingredients: this.compose })
      if (r) {
        this.compose = r.ingredients
      }
    },
    async getingreds () {
      const params = {}
      if (this.searchText) {
        params.searchText = this.searchText
      }
      this.ingreds = await getapi(`ingredients?${new URLSearchParams(params)}`)
    }
  }
}
</script>
<style lang="scss">
#ingredient {
  height: calc(100vh - 190px)!important;
  flex:1;
  .La1_right {
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
button.del {
  margin-left: auto;
  background: #E37878;
  mask-image: url(/svg/btn/del.svg);
  width: 28px;
  height: 28px;
  mask-size: 25px;
  mask-repeat: no-repeat;
  mask-position: center;

}
button.add {
  background-color: var(--color-pri);
  mask-image: url(/svg/btn/add.svg);
  width: 28px;
  height: 28px;
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}
.items {
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  &>div{
    height: 55px;
    display: flex;
    padding: 10px 25px;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    font-weight: 500;
    font-size: 18px;
    line-height: 180%;
    display: flex;
    align-items: center;
    text-align: start;
    letter-spacing: 0.1em;
    color: #787878;
  }
}
.save {
  width: 80px;
  height: 30px;
  background-color: #FFFFFF;
  border-radius: 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 180%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--color-pri);
}

.search {
  width: 228px;
  height: 30px;
  border-radius: 15px;
  padding-inline: 1em;
  font-weight: 400;
  font-size: 14px;
  line-height: 180%;
}
.cubes {
  border-radius: 10px;
  border: 1px solid;
  flex: 1;
  height: fill;
  display: grid;
  grid-template-rows: 45px 1fr;
  &>div:nth-child(1) {
    padding-inline: 25px;
    height: 45px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 18px;
    line-height: 180%;
    border-radius: 10px 10px 0 0 ;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &>div:nth-child(2) {
    flex: 1;

  }
}
</style>
